import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["children"];
import PropTypes from 'prop-types';
import React from 'react';
import { withIcon } from '../Icon';
export var EqualHousingSVG = function EqualHousingSVG(_ref) {
  var children = _ref.children,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M29.47 11.12l-13-7a1 1 0 00-.94 0l-13 7a1 1 0 10.94 1.76L5 12.06V26a2 2 0 002 2h18a2 2 0 002-2V12.06l1.53.82a1 1 0 10.94-1.76zM21 21H11a1 1 0 010-2h10a1 1 0 010 2zm0-4H11a1 1 0 010-2h10a1 1 0 010 2z"
  }));
};
EqualHousingSVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: PropTypes.node
} : {};
export default withIcon(EqualHousingSVG);